import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";

interface DetailsCardProps {
  heading?: string;
  subHeading?: string;
  firstInputId?: string;
  firstInputLabel?: string;
  firstInputPlaceholder?: string;
  firstInputOnChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  secondInputId?: string;
  secondInputLabel?: string;
  secondInputPlaceholder?: string;
  secondInputOnChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  isRadioButtons?: boolean;
  radioGroupLabel?: string;
  radioGroupName?: string;
  value: string;
  secondValue?:string;
  formControlLabelList?: { value: string; label: string }[];
}
const DetailsCard = ({
  heading,
  subHeading,
  firstInputOnChange,
  firstInputId,
  firstInputLabel,
  firstInputPlaceholder,
  secondInputId,
  secondInputLabel,
  secondInputPlaceholder,
  secondInputOnChange,
  isRadioButtons,
  radioGroupLabel,
  radioGroupName,
  value,
  secondValue,
  formControlLabelList = [],
}: DetailsCardProps) => {
  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      gap={2}
      sx={{ backgroundColor: "#ffffff" }}
      border={"1px solid #0000000F"}
      padding={"16px 24px"}
      borderRadius={1}
    >
      <Box>
        <Typography
          variant="subtitle2"
          fontWeight={500}
          sx={{ color: "#171D1A" }}
        >
          <span style={{ color: "#CD3535" }}>*</span> {heading}
        </Typography>

        <Typography variant="body2" color="action.disabled">
          {subHeading}
        </Typography>
      </Box>
      {firstInputLabel && (
        <TextField
          id={firstInputId}
          label={firstInputLabel}
          size="small"
          value={value}
          onChange={firstInputOnChange}
          variant="outlined"
          placeholder={firstInputPlaceholder}
        />
      )}

      {secondInputLabel && (
        <TextField
          id={secondInputId}
          label={secondInputLabel}
          size="small"
          value={secondValue}
          onChange={secondInputOnChange}
          variant="outlined"
          placeholder={secondInputPlaceholder}
        />
      )}

      {isRadioButtons && (
        <FormControl>
          <RadioGroup
            row
            aria-labelledby={radioGroupLabel}
            name={radioGroupName}
            value={value}
            onChange={firstInputOnChange}
          >
            {formControlLabelList.map((item, index) => (
              <FormControlLabel
                key={index}
                value={item.value}
                control={<Radio />}
                label={item.label}
                sx={{
                  '& .MuiFormControlLabel-label': {
                    color: '#171D1A',
                    fontWeight: 400,
                  },
                }}
              />
            ))}
          </RadioGroup>
        </FormControl>
      )}
    </Box>
  );
};

export default DetailsCard;
